<template>
    <div class="article_modal_container">
        <div class="article_modal">
            <div class="x_btn" @click="closeModal">ⓧ</div>

            <div class="title_text">{{selectedArticleTitle}}</div>

            <div style="margin:10px; text-align:center;">
                <img :src="img">
            </div>

            <div style="padding:10px; font-size:16px; overflow:auto; height:130px;">
                {{selectedArticleDesc}}
            </div>

            <div class="button_container">
                <div @click="closeModal" class="close_btn">돌아가기</div>
                <div @click="clickNext" class="select_btn">시작하기</div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArticleInfoModal',

    props: {
        selectedArticleTitle: String,
        selectedArticleDesc: String,
        selectedArticleImage: String,
        selectedArticleIndex: Number
    },

    data() {
        return {
            img: null
        }
    },

    mounted() {
        // this.img = this.$imgPath + this.selectedArticleImage
        this.img = require('../assets/articles/' + this.selectedArticleImage)
    },

    methods: {
        clickNext: function() {
            let currentGame = this.$getCurrentGame()
            currentGame.selectedArticle = this.selectedArticleIndex
            this.$setCurrentGame(currentGame)

            this.$router.push('/clueList3')
        },
        
        closeModal: function() {
            this.$emit('close_article_info_modal')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.article_modal_container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    /* height: 620px; */
    background-color: #000000cc;
    top: 0px;
    left: 0px;
    z-index: 2;
}

/* pc */
@media screen and (min-width: 415px) {
    .article_modal {
        position: fixed;
        width: 460px;
        height: 480px;
        background-color: white;
        left: calc((1280px / 2) - (460px / 2));
        top: calc((620px / 2) - (480px / 2) - 20px);
        padding: 10px;
        border-radius: 5px;
        overflow: hidden;
    }
    .x_btn {
        height:30px;
        font-size:26px;
        padding:0px 3px;
        font-weight:700;
        text-align: right;
        cursor:pointer;
    }
    .select_btn {
        margin-top: 10px;
        margin-bottom: 0px;
        margin-left: 20px;
        margin-right: 20px;
        font-size: 26px;
        text-align:center;
        padding: 5px;
        border:2px solid black;
        box-shadow: 2px 2px 2px gray;
        cursor:pointer;
    }
    img {
        width: 400px;
        height: 150px;
        background-color:gray;
    }
    .close_btn {
        display: none;
    }
    .button_container {
        display: block;
    }
    .title_text {
        font-size:20px;
        font-weight:700;
        text-align:center;
        word-break: keep-all;
    }

}
/* mobile */
@media screen and (max-width: 414px) {
    .article_modal {
        position: fixed;
        width: 340px;
        height: 430px;
        background-color: white;
        left: calc((100vw / 2) - (340px / 2));
        top: calc((100vh / 2) - (430px / 2) - 50px);
        overflow: hidden;
    }
    img {
        /* width: 300px; */
        height: 110px;
        background-color:gray;
    }
    .x_btn {
        display: none;
    }
    .button_container {
        margin-top: 40px;
        border-top: black solid 1px;
        display: flex;
        font-size: 26px;
        text-align: center;
    }
    .select_btn {
        padding: 10px;
        flex-grow: 1;
        background-color: white;
    }
    .close_btn {
        padding: 10px;
        flex-grow: 1;
        background-color: gray;
    }
    .title_text {
        height: 60px;
        margin: 10px;
        font-size:20px;
        font-weight:700;
        text-align:center;
        word-break: keep-all;
    }

}
</style>
